// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import uuidv4 from 'uuid/v4';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { getTotal } from '../../../../pages/basket/store/selectors';
import history from '../../../../services/history';
import basket from '../../../../images/basket.png';
import login from '../../../../images/login.png';
import logo from '../../../../images/logo.png';
import styles from './styles.js';
import Button from '../../../Button/Button';
import MobileMenu from '../../components/MobileMenu';

class MainHeader extends Component {
  static propTypes = {
    classes: PropTypes.object,
    data: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string,
      menu: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        link: PropTypes.string,
      })),
    })),
    total: PropTypes.object,
    current_page: PropTypes.string,
    isIndex: PropTypes.bool,
  };

  static defaultProps = {
    classes: {},
    data: [{
      type: 'leftMenu',
      menu: [{
        label: 'no link',
        link: '/',
      }],
    }],
    total: {
      price: 0,
      items: 0,
    },
    current_page: null,
    isIndex: false,
  };

  getLinkLeft = (data) => {
    const { classes, current_page } = this.props;
    const color = current_page === data.label ? classes.blueColor : null;
    return (
      <div key={uuidv4()} className={classes.linkContainer}>
        <Link className={classNames(classes.link, classes.menuTextLeft, color)} to={data.link}>
          {data.label}
        </Link>
      </div>
    );
  }

  render() {
    const {
      classes, data, isIndex, total,
    } = this.props;
    const leftMenu = data.find(e => e.type === 'leftMenu').menu;
    const mainMenu = data.find(e => e.type === 'mainMenu').menu;

    const logged = localStorage.getItem('loggedID');

    let needItem = 10;
    let needMoney = 10;
    needMoney = 10 - total.price;
    needMoney = parseFloat(Math.round(needMoney * 100) / 100).toFixed(2);
    needItem = 10 - total.items;
    const isAll = needMoney <= 0 || needItem <= 0;

    return (
      <header className={classes.header}>
        <div className={classes.logoContainer}>
          <MediaQuery maxWidth={1150}>
            <div className={classes.menuIconContainer}>
              <MobileMenu leftMenu={leftMenu} />
            </div>
          </MediaQuery>
          <Link to={'/'} className={classes.logo}>
            <img className={classes.logoImage} src={logo} alt={'logo'} />
          </Link>
        </div>
        <div className={classes.menuContainer}>
          <MediaQuery minWidth={1151}>
            <div className={classNames(classes.menuContainer, classes.menuLeft)}>
              {leftMenu.map(item => this.getLinkLeft(item))}
            </div>
          </MediaQuery>
          <Button
            text={'sell an item'}
            onPress={() => history.push('/basket')}
            style={classes.buttonStyle}
            isMainButton
          />
          <div className={classNames(classes.menuContainerRight,
            isIndex ? classes.menuRightIndex : classes.menuRight)}
          >
            {mainMenu.map(item => (
              <div key={uuidv4()} className={classes.linkContainer}>
                <Link
                  className={classNames(classes.menuTextRight, classes.flexDirectionColumn)}
                  to={(item.link === '/login' && logged) ? '/account' : item.link}
                >
                  {item.label === 'basket' && (
                    <div className={classes.imageContainer}>
                      <img className={classes.image} src={basket} alt="basket" />
                      <div className={classNames(
                        classes.counterContainer,
                        isAll ? classes.isAll : classes.isNotAll,
                      )}
                      >
                        <span className={classes.counter}>{total.items}</span>
                      </div>
                    </div>)}
                  {item.label === 'login' && (
                    <div className={classes.imageContainer}>
                      <img className={classes.image} src={login} alt="login" />
                    </div>)}
                  <span className={classes.menuTextRight}>
                    {(item.label === 'login' && logged) ? 'account' : item.label}
                  </span>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </header>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    current_page: state.globalReducer.current_page,
    total: getTotal(state),
  };
};

export default connect(mapStateToProps)(withStyles(styles)(MainHeader));
